import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import copy from "copy-to-clipboard";
import { usePopup } from "../../../shared/hooks/usePopup";
import HistoryUseCase from "../../../features/transaction-history/domain/usecases/HistoryUseCase";
import TransactionApi from "../../../features/transaction-history/data/HistoryApi";

export function useInvoice(bookId: string | null | undefined) {
  const { showPopup, showSnackbar, handleErrorResponse } = usePopup();

  const repository = new HistoryUseCase(new TransactionApi());
  const {
    refetch: fetchGenerateLink,
    data: generatedLinkResult,
    isLoading,
    error,
    isError,
  } = useQuery({
    enabled: false,
    refetchOnWindowFocus: false,
    retry: false,
    queryKey: ["generateLink"],
    queryFn: () => repository.getGenerateLink(bookId ?? ""),
  });

  useEffect(() => {
    if (!isLoading && generatedLinkResult) {
      copy(generatedLinkResult);
      showSnackbar("Teks berhasil disalin!");
    }
  }, [isLoading, generatedLinkResult]);

  useEffect(() => {
    if (error && error instanceof AxiosError && isError) {
      handleErrorResponse(error);
    }
  }, [error, isError]);

  return { fetchGenerateLink };
}
